import { css, unsafeCSS } from 'lit';

import token from '../../../utils/get-token';
import color from '../../../utils/get-color-token';

import { defaultBoxProps } from './box.constants';

export function boxStyles() {
	return css`
		:host {
			--m-box-padding: ${token(defaultBoxProps.padding)};
			--m-box-background-color: transparent;
			--m-box-border-radius: ${token(defaultBoxProps.borderRadius)};
			--m-box-border-width: ${token(defaultBoxProps.borderWidth)};
			--m-box-border-color: ${color(defaultBoxProps.borderColor)};
			--m-box-text-align: ${unsafeCSS(defaultBoxProps.textAlign)};

			box-sizing: border-box;

			padding: var(--m-box-padding);
			background-color: var(--m-box-background-color);
			border-radius: var(--m-box-border-radius);
			border-style: solid;
			border-width: var(--m-box-border-width);
			border-color: var(--m-box-border-color);
			text-align: var(--m-box-text-align);
		}
	`;
}
